import React from "react";

import { Button } from "antd";
import dynamic from "next/dynamic";

const UIIcon = dynamic(() => import("./UIIcon.js"));

function UIButton({
  children,
  htmlType,
  icon,
  type = "primary",
  onClick = () => {},
  full = false,
  className = "",
  loading = false,
  iconSize,
  iconColor = "#fff",
  disabled,
  style,
  size,
}) {
  if(type == 'secondary') type = undefined
  return (
    <Button
      size={size ? size : "large"}
      htmlType={htmlType}
      disabled={disabled}
      loading={loading}
      type={type}
      onClick={onClick}
      className={full ? `full-button` : className}
      style={{ borderRadius: "12px", ...style }}>
      {icon && <UIIcon Icon={icon} size={iconSize} iconColor={iconColor} color={iconColor} />}
      {children && <span className={icon ? `icon-text` : ``} style={{fontWeight: 'bold', padding: 0}}>{children}</span>}
    </Button>
  );
}

export default UIButton;
